/**
 * Infra AI markası — Infra beyaz, AI parlak cyan, aralarında boşluk.
 * Tüm sayfada aynı görünüm (hero, header, footer, bölüm başlıkları).
 */
export function InfraAIWordmark({ variant = "inline", className = "", suffix = null }) {
  const variantClass =
    variant === "hero"
      ? "hero-logo-wordmark"
      : variant === "sm"
        ? "infra-ai-wordmark--sm"
        : "infra-ai-wordmark--inline";

  return (
    <span
      className={`infra-ai-wordmark ${variantClass} ${className}`.trim()}
      aria-label="Infra AI"
    >
      <span className="hero-logo-infra">Infra</span>
      <span className="hero-logo-ai">AI</span>
      {suffix != null && suffix !== "" ? <span>{suffix}</span> : null}
    </span>
  );
}

/** Metin içindeki InfraAI / Infra AI ifadelerini wordmark ile render eder */
export function InfraAIText({ children, className = "", wordmarkClassName = "" }) {
  if (children == null) return null;
  if (typeof children !== "string") return children;

  const parts = children.split(/(Infra\s*AI)/gi);
  if (parts.length === 1) {
    return className ? <span className={className}>{children}</span> : children;
  }

  return (
    <span className={className}>
      {parts.map((part, i) => {
        if (!part) return null;
        if (/^Infra\s*AI$/i.test(part)) {
          return (
            <InfraAIWordmark
              key={i}
              variant="inline"
              className={wordmarkClassName}
            />
          );
        }
        return <span key={i}>{part}</span>;
      })}
    </span>
  );
}
